import DashboardLayout from '@/layouts/Dashboard/DashboardLayout';
import { ScenarioProvider, TagProvider } from '@/shared/providers';

const DashboardContainer = () => {
  return (
    <TagProvider>
      <ScenarioProvider>
        <DashboardLayout />
      </ScenarioProvider>
    </TagProvider>
  );
};

export default DashboardContainer;
